import React from 'react'
import type { LotteryRound } from '../../services/lotteryService'
import { getWinningNumbers, hasAnyResult, displayValue, getDrawLabelNgod } from './resultDisplayUtils'
import LotteryResultSectionHeader from './LotteryResultSectionHeader'
import { getImageUrl } from '../../utils/cdnUtils'

type Props = {
  sectionTitle: string
  rounds: LotteryRound[]
  onRoundClick?: (round: LotteryRound) => void
}

/** Section: หวยชุด - เลขชุด 4 ตัว, 3ตัวบน, 2ตัวหน้า, 2ตัวหลัง. One section header, then wrap-box bgc-14 with multiple cards (col-6 col-lg-3). */
const LotteryResultSectionSet: React.FC<Props> = ({
  sectionTitle,
  rounds,
  onRoundClick,
}) => {
  const firstRound = rounds[0]
  const drawLabel = firstRound ? getDrawLabelNgod(firstRound) : ''

  return (
    <div className="col-12 px-1 mb-4">
      <LotteryResultSectionHeader
        title={sectionTitle}
        iconUrl={firstRound?.huayTypeIcon}
        drawLabel={drawLabel}
      />
      <div className="wrap-box p-2 pt-0 bgc-14 bdr-5">
        <div className="row mx--1">
          {rounds.map((round) => {
            const wn = getWinningNumbers(round)
            const hasResult = hasAnyResult(round)
            const isCancelled = round.status === 'cancelled'
            const disp = (v: string) => displayValue(v, { isCancelled, hasResult })
            const isClickable = !!onRoundClick
            return (
              <div
                key={round._id}
                className="col-6 col-lg-3 px-1 mt-2 animateMe"
                data-animation="fadeInUp"
              >
                <div
                  className="bgg-6 bdr-5 bx-sd p-2 text-center h-100"
                  style={isClickable ? { cursor: 'pointer' } : undefined}
                  onClick={() => onRoundClick?.(round)}
                  onKeyDown={(e) => e.key === 'Enter' && onRoundClick?.(round)}
                  role={isClickable ? 'button' : undefined}
                  tabIndex={isClickable ? 0 : undefined}
                >
                  <div className="wrap bgi-3 bdr-5 px-1 mb-1 bx-sd">
                    <div className="icon-s">
                      <img src={getImageUrl(round.huayTypeIcon || 'logo.png')} alt="" />
                    </div>
                    <h6 className="mx-2 t-regular c-white">{round.huayName}</h6>
                  </div>
                  {/* ตรงภาพ/HTML: การ์ดหวยชุดแสดงเฉพาะ เลขชุด 4 ตัว */}
                  <div className="row mx--2">
                    <div className="col px--1">
                      <div className="t-medium c-white text-center">
                        <small>เลขชุด 4 ตัว</small>
                      </div>
                      <div className="px-1 bg-white bdr-5 bx-sd p-1 text-center">
                        <h5>{disp(wn.fourUp)}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default LotteryResultSectionSet
